// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SystemDetailsQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type SystemDetailsQuery = {
  __typename?: "GraphqlQuery";
  getSystemDetails: {
    __typename?: "SystemDetails";
    id: string;
    info?: {
      __typename?: "SystemInfo";
      systemType?: string | null;
      amazonRdsEnhanced?: boolean | null;
      supportsCpuMetrics: boolean;
      supportsMemoryMetrics: boolean;
      supportsIoMetrics: boolean;
      supportsNetworkMetrics: boolean;
      cpuUtilizationOnly: boolean;
      crunchyBridgeClusterId?: string | null;
      data?: {
        __typename?: "SystemInfoData";
        autoMinorVersionUpgrade?: boolean | null;
        availabilityZone?: string | null;
        backupRetentionPeriod?: number | null;
        instanceClass?: string | null;
        instanceId?: string | null;
        latestRestorableTime?: string | null;
        multiAz?: boolean | null;
        operatingSystem?: string | null;
        parameterApplyStatus?: string | null;
        platform?: string | null;
        platformVersion?: string | null;
        preferredBackupWindow?: string | null;
        preferredMaintenanceWindow?: string | null;
        publiclyAccessible?: boolean | null;
        region?: string | null;
        secondaryAvailabilityZone?: string | null;
        status?: string | null;
        storageProvisionedIops?: string | null;
        storageType?: string | null;
        virtualizationSystem?: string | null;
        isAuroraPostgres?: boolean | null;
        clusterName?: string | null;
        planId?: string | null;
        providerId?: string | null;
        regionId?: string | null;
        cpuUnits?: number | null;
        storageGb?: number | null;
        memoryGb?: number | null;
        location?: string | null;
        state?: string | null;
        subscriptionId?: string | null;
        resourceGroup?: string | null;
        resourceType?: string | null;
        resourceName?: string | null;
        highAvailabilityMode?: string | null;
        highAvailabilityState?: string | null;
        replicationRole?: string | null;
        citusVersion?: string | null;
        highAvailabilityEnabled?: boolean | null;
        coordinatorStorageMb?: number | null;
        nodeStorageMb?: number | null;
        coordinatorVcores?: number | null;
        nodeVcores?: number | null;
        nodeCount?: number | null;
        skuName?: string | null;
        coordinatorServerEdition?: string | null;
        nodeServerEdition?: string | null;
      } | null;
    } | null;
    stats?: {
      __typename?: "SystemStats";
      cpuHardwareModel?: string | null;
      cpuHardwareSockets?: number | null;
      cpuHardwareCoresPerSocket?: number | null;
      storageMountpoint?: string | null;
    } | null;
  };
};

export const SystemDetailsDocument = gql`
  query SystemDetails($serverId: ID!) {
    getSystemDetails(serverId: $serverId) {
      id
      info {
        systemType
        amazonRdsEnhanced
        supportsCpuMetrics
        supportsMemoryMetrics
        supportsIoMetrics
        supportsNetworkMetrics
        cpuUtilizationOnly
        crunchyBridgeClusterId
        data {
          autoMinorVersionUpgrade
          availabilityZone
          backupRetentionPeriod
          instanceClass
          instanceId
          latestRestorableTime
          multiAz
          operatingSystem
          parameterApplyStatus
          platform
          platformVersion
          preferredBackupWindow
          preferredMaintenanceWindow
          publiclyAccessible
          region
          secondaryAvailabilityZone
          status
          storageProvisionedIops
          storageType
          virtualizationSystem
          isAuroraPostgres
          clusterName
          planId
          providerId
          regionId
          cpuUnits
          storageGb
          memoryGb
          location
          state
          subscriptionId
          resourceGroup
          resourceType
          resourceName
          highAvailabilityMode
          highAvailabilityState
          replicationRole
          citusVersion
          highAvailabilityEnabled
          coordinatorStorageMb
          nodeStorageMb
          coordinatorVcores
          nodeVcores
          nodeCount
          skuName
          coordinatorServerEdition
          nodeServerEdition
        }
      }
      stats {
        cpuHardwareModel
        cpuHardwareSockets
        cpuHardwareCoresPerSocket
        storageMountpoint
      }
    }
  }
`;

/**
 * __useSystemDetailsQuery__
 *
 * To run a query within a React component, call `useSystemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemDetailsQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useSystemDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SystemDetailsQuery,
    SystemDetailsQueryVariables
  > &
    (
      | { variables: SystemDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SystemDetailsQuery, SystemDetailsQueryVariables>(
    SystemDetailsDocument,
    options,
  );
}
export function useSystemDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SystemDetailsQuery,
    SystemDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SystemDetailsQuery, SystemDetailsQueryVariables>(
    SystemDetailsDocument,
    options,
  );
}
// @ts-ignore
export function useSystemDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SystemDetailsQuery,
    SystemDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SystemDetailsQuery,
  SystemDetailsQueryVariables
>;
export function useSystemDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SystemDetailsQuery,
        SystemDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SystemDetailsQuery | undefined,
  SystemDetailsQueryVariables
>;
export function useSystemDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SystemDetailsQuery,
        SystemDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SystemDetailsQuery,
    SystemDetailsQueryVariables
  >(SystemDetailsDocument, options);
}
export type SystemDetailsQueryHookResult = ReturnType<
  typeof useSystemDetailsQuery
>;
export type SystemDetailsLazyQueryHookResult = ReturnType<
  typeof useSystemDetailsLazyQuery
>;
export type SystemDetailsSuspenseQueryHookResult = ReturnType<
  typeof useSystemDetailsSuspenseQuery
>;
export type SystemDetailsQueryResult = Apollo.QueryResult<
  SystemDetailsQuery,
  SystemDetailsQueryVariables
>;
